import React, { useState, useEffect } from "react";
import { Box, Typography, Grid, Card, CardContent, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button } from "@mui/material";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn"; // Green Dollar Icon
import AccessTimeIcon from "@mui/icons-material/AccessTime"; // Clock Icon (Pending)
import TrendingUpIcon from "@mui/icons-material/TrendingUp"; // Market (Available for Sale)
import { getCarbonCredits } from "../services/api"; // API call to fetch carbon credits

const CarbonCredits = () => {
    const [creditsData, setCreditsData] = useState({
        totalEarned: 0,
        pendingCredits: 0,
        availableForSale: 0,
        transactions: []
    });

    useEffect(() => {
        //fetchCarbonCredits();
    }, []);

    const fetchCarbonCredits = async () => {
        try {
            const { data } = await getCarbonCredits();
            
            let totalEarned = 0, pendingCredits = 0, availableForSale = 0;
            const transactions = [];

            data.forEach((credit, index) => {
                totalEarned += credit.creditsEarned;
                pendingCredits += credit.creditsPending;
                availableForSale += credit.creditsAvailable;

                if (index < 3) { // Limit to 3 recent transactions
                    transactions.push({
                        projectName: `Project ${index + 1}`,
                        credits: credit.creditsEarned,
                        status: credit.creditsPending > 0 ? "Pending" : "Verified",
                        date: new Date().toISOString().split("T")[0]
                    });
                }
            });

            setCreditsData({ totalEarned, pendingCredits, availableForSale, transactions });
        } catch (error) {
            console.error("Error fetching carbon credits", error);
        }
    };

    return (
        <Box sx={{ padding: "20px" }}>
            {/* Title */}
            <Typography variant="h4" fontWeight="bold">
                Carbon Credits Dashboard
            </Typography>
            <Typography variant="body1" color="textSecondary">
                Track and manage your carbon credit portfolio
            </Typography>

            {/* KPI Cards */}
            <Grid container spacing={3} sx={{ marginTop: 2 }}>
                {/* Total Earned */}
                <Grid item xs={12} sm={4}>
                    <Card sx={{ background: "#E7F3EC", padding: "16px", borderRadius: "10px" }}>
                        <CardContent>
                            <Box display="flex" justifyContent="space-between" alignItems="center">
                                <MonetizationOnIcon sx={{ color: "#2E7D32", fontSize: 30 }} />
                                <Typography variant="body2" color="textSecondary">Active</Typography>
                            </Box>
                            <Typography variant="h6" fontWeight="bold">Total Earned Credits</Typography>
                            <Typography variant="h3" fontWeight="bold">{creditsData.totalEarned.toLocaleString()}</Typography>
                            <Typography variant="body2" color="textSecondary">Carbon Credits</Typography>
                        </CardContent>
                    </Card>
                </Grid>

                {/* Pending Credits */}
                <Grid item xs={12} sm={4}>
                    <Card sx={{ background: "#FFF3CD", padding: "16px", borderRadius: "10px" }}>
                        <CardContent>
                            <Box display="flex" justifyContent="space-between" alignItems="center">
                                <AccessTimeIcon sx={{ color: "#FF9800", fontSize: 30 }} />
                                <Typography variant="body2" color="textSecondary">Pending</Typography>
                            </Box>
                            <Typography variant="h6" fontWeight="bold">Pending Credits</Typography>
                            <Typography variant="h3" fontWeight="bold">{creditsData.pendingCredits.toLocaleString()}</Typography>
                            <Typography variant="body2" color="textSecondary">Carbon Credits</Typography>
                        </CardContent>
                    </Card>
                </Grid>

                {/* Available for Sale */}
                <Grid item xs={12} sm={4}>
                    <Card sx={{ background: "#D6E4FF", padding: "16px", borderRadius: "10px" }}>
                        <CardContent>
                            <Box display="flex" justifyContent="space-between" alignItems="center">
                                <TrendingUpIcon sx={{ color: "#1565C0", fontSize: 30 }} />
                                <Typography variant="body2" color="textSecondary">Market</Typography>
                            </Box>
                            <Typography variant="h6" fontWeight="bold">Available for Sale</Typography>
                            <Typography variant="h3" fontWeight="bold">{creditsData.availableForSale.toLocaleString()}</Typography>
                            <Typography variant="body2" color="textSecondary">Carbon Credits</Typography>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>

            {/* Recent Transactions */}
            <Box sx={{ marginTop: 4 }}>
                <Typography variant="h6" fontWeight="bold">Recent Transactions</Typography>
                
                <TableContainer component={Paper} sx={{ marginTop: 2, borderRadius: "10px" }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ fontWeight: "bold" }}>Project Name</TableCell>
                                <TableCell sx={{ fontWeight: "bold" }}>Credits</TableCell>
                                <TableCell sx={{ fontWeight: "bold" }}>Status</TableCell>
                                <TableCell sx={{ fontWeight: "bold" }}>Date</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {creditsData.transactions.map((transaction, index) => (
                                <TableRow key={index}>
                                    <TableCell>{transaction.projectName}</TableCell>
                                    <TableCell>{transaction.credits.toLocaleString()}</TableCell>
                                    <TableCell>
                                        <Typography sx={{
                                            background: transaction.status === "Verified" ? "#C8E6C9" : "#FFF3CD",
                                            padding: "5px 10px",
                                            borderRadius: "8px",
                                            display: "inline-block"
                                        }}>
                                            {transaction.status}
                                        </Typography>
                                    </TableCell>
                                    <TableCell>{transaction.date}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

                {/* View All Button */}
                <Box display="flex" justifyContent="flex-end" sx={{ marginTop: 2 }}>
                    <Button variant="outlined" size="small">View All</Button>
                </Box>
            </Box>
        </Box>
    );
};

export default CarbonCredits;
